import { cssColors } from "./css-colors";
var Hsv = /** @class */ (function () {
    function Hsv($, s, v) {
        this.$ = $;
        this.v = v;
        this.s = s;
    }
    return Hsv;
}());
export { Hsv };
var ColorUtilities = /** @class */ (function () {
    function ColorUtilities() {
    }
    ColorUtilities.rgbToHex = function (r, g, b) {
        if (r > 255 || g > 255 || b > 255) {
            throw new Error("Invalid color component");
        }
        var a1 = (r + 0x10000).toString(16).substr(-2).toLowerCase();
        var a2 = (g + 0x10000).toString(16).substr(-2).toLowerCase();
        var a3 = (b + 0x10000).toString(16).substr(-2).toLowerCase();
        return a1 + a2 + a3;
    };
    ColorUtilities.getRgbColor = function (color) {
        if (!color) {
            return { r: 0, g: 0, b: 0 };
        }
        var colorFromCss = cssColors[color.toLowerCase()];
        if (colorFromCss) {
            return ColorUtilities.hexToRgba(colorFromCss);
        }
        else {
            var rgb = ColorUtilities.hexToRgba(color);
            if (rgb) {
                return rgb;
            }
        }
        return { r: 0, g: 0, b: 0 };
    };
    ColorUtilities.isRgba = function (object) {
        return typeof object == "object" && ColorUtilities.isRgb(object) && 'a' in object;
    };
    ColorUtilities.isRgb = function (object) {
        return typeof object == "object" && 'r' in object && 'g' in object && 'b' in object;
    };
    ColorUtilities.isValid = function (color) {
        if (!color) {
            return false;
        }
        if (ColorUtilities.isRgb(color) || ColorUtilities.isRgba(color)) {
            return true;
        }
        var colorFromCss = cssColors[color.toLowerCase()];
        if (colorFromCss) {
            return true;
        }
        else {
            var rgb = ColorUtilities.hexToRgba(color);
            if (rgb) {
                return true;
            }
        }
        return false;
    };
    ColorUtilities.colorLuminance = function (hex, lum) {
        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;
        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    };
    ColorUtilities.hsv2rgb = function (h, s, v) {
        var r, g, b;
        var i;
        var f, p, q, t;
        // Make sure our arguments stay in-range
        h = Math.max(0, Math.min(360, h));
        s = Math.max(0, Math.min(100, s));
        v = Math.max(0, Math.min(100, v));
        // We accept saturation and value arguments from 0 to 100 because that's
        // how Photoshop represents those values. Internally, however, the
        // saturation and value are calculated from a range of 0 to 1. We make
        // That conversion here.
        s /= 100;
        v /= 100;
        if (s == 0) {
            // Achromatic (grey)
            r = g = b = v;
            return {
                r: Math.round(r * 255),
                g: Math.round(g * 255),
                b: Math.round(b * 255)
            };
        }
        h /= 60; // sector 0 to 5
        i = Math.floor(h);
        f = h - i; // factorial part of h
        p = v * (1 - s);
        q = v * (1 - s * f);
        t = v * (1 - s * (1 - f));
        switch (i) {
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            default: // case 5:
                r = v;
                g = p;
                b = q;
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    };
    ColorUtilities.rgbToHsv = function (r, g, b) {
        var h, s, v;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var delta = max - min;
        // hue
        if (delta === 0) {
            h = 0;
        }
        else if (r === max) {
            h = ((g - b) / delta) % 6;
        }
        else if (g === max) {
            h = (b - r) / delta + 2;
        }
        else if (b === max) {
            h = (r - g) / delta + 4;
        }
        h = Math.round(h * 60);
        if (h < 0) {
            h += 360;
        }
        // saturation
        s = Math.round((max === 0 ? 0 : (delta / max)) * 100);
        // value
        v = Math.round(max / 255 * 100);
        return {
            h: h,
            s: s,
            v: v
        };
    };
    ;
    ColorUtilities.isHex = function (str) {
        if (!str || str.length === 0) {
            return false;
        }
        for (var i = 0; i < str.length; i++) {
            if (isNaN(parseInt(str.charAt(i), 16))) {
                return false;
            }
        }
        return true;
    };
    ColorUtilities.hexToRgba = function (hex) {
        if (!hex || hex.length === 0) {
            return null;
        }
        if (hex[0] === "#") {
            hex = hex.substr(1);
        }
        if (!this.isHex(hex)) {
            return null;
        }
        if (hex.length === 6) {
            return {
                r: parseInt(hex.substr(0, 2), 16),
                g: parseInt(hex.substr(2, 2), 16),
                b: parseInt(hex.substr(4, 2), 16),
                a: 1
            };
        }
        else if (hex.length === 3) {
            return {
                r: parseInt(hex[0] + hex[0], 16),
                g: parseInt(hex[1] + hex[1], 16),
                b: parseInt(hex[2] + hex[2], 16),
                a: 1
            };
        }
        else {
            return null;
        }
    };
    ;
    return ColorUtilities;
}());
export { ColorUtilities };
